import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=6959857e&scoped=true&"
import script from "./buy.vue?vue&type=script&lang=js&"
export * from "./buy.vue?vue&type=script&lang=js&"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=6959857e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../code/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959857e",
  null
  
)

export default component.exports